import Appsignal from "@appsignal/javascript"

const appsignal = new Appsignal({
  key: import.meta.env.VITE_APPSIGNAL_FRONTEND_KEY
})

export default appsignal